



























import Vue from "vue";
import uploader from './uploader.vue';

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    attachmentList: {
      type: Array,
      default: ()=>[]
    }
  },
  computed:{
    imageList:{
      get(){
        const list =  this.attachmentList.filter(e => e.type === 'image');
        return list;
      },
    },
    videoList:{
      get(){
        const list =  this.attachmentList.filter(e => e.type === 'video');
        return list;
      },
    }
  },
  components: {uploader},
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 }
    }
  }
});
